<template>
  <v-layout wrap row>
    <v-flex xs12 my-2 mt-4 style="text-transform:uppercase;font-weight:bold;">
      Vendor Sub SKUs
    </v-flex>
    <v-flex xs12>
      <v-layout wrap row>
        <v-flex xs12 md12 pb-1 v-for="(sub, p) in vendorsubs" :key="'price-' + p ">
          <v-layout wrap row>
            <v-flex xs6 md2 px-1>
              <v-text-field
                label="SKU"
                outline
                :readonly="false"
                :disabled="false"
                hide-details
                v-model="sub.sku"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 md4 px-1>
              <v-autocomplete
                :items="resource.allusers"
                :filter="filterObject"
                outline
                item-value="id"
                hide-details
                v-model="sub.account_id"
                label="User"
              >
                <template
                    slot="selection"
                    slot-scope="{ item }"
                  >
                    {{item.name}} | {{item.id}}
                  </template>
                  <template
                    slot="item"
                    slot-scope="{ parent, item }"
                    class="py-1"
                  >
                    {{item.name}} | {{item.id}}
                  </template>
              </v-autocomplete>
            </v-flex>
            <v-flex xs6 md2 px-1>
              <v-text-field
                label="MAX. Discount Allowed"
                outline
                hide-details
                v-model="sub.discount"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md2 px-1>
              <v-switch label="Active" v-model="sub.active"></v-switch>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          
          <v-btn color="primary" block @click="newVendorSub()">add sub</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { firebase, store, db, auth, storageRef } from '@/fb';
import { VueEditor } from "vue2-editor";
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';

export default {
  components: {
    VueEditor
  },
  props:['dialog', 'deleting', 'resourceKeys', 'newResource', 'loading', 'resourceSettings', 'resource', 'vendorsubs'],
  data(){
    return {
      rules: {
        required: value => !!value || 'required',
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || 'valid_email'
      },
      datepicker:{},
      timepicker:{},
      menu:{},
      uploadProgress:0,
      file:null,
      name:null,
      uploadURL:null,
    }
  },
  methods: {
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    removeVendorSub(variant) {
      this.$emit('removeVendorSub', variant )
    },
    newVendorSub(){
      this.$emit('newVendorSub', {} )
    },
    getNameID(){
      return randomString(24, '#Aa') + `${new Date().getTime()}`
    },
    validate(newResource, notify) {
      let fsr = this.resourceKeys.filter(x=>x.required)
      let fse = this.resourceKeys.filter(x=>x.email)
      let v = true
      fsr.forEach(x=>{
        if(!newResource[x.name]) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${x.name} required`, 'error')
        }
      })
      fse.forEach(x=>{
        if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(newResource[x.name])) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `Not valid email`, 'error')
        }
      })
      return v
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    deleteResource(newResource) {
      this.$emit('deleteResource', newResource)
    },
    updateResource(newResource) {
      this.$emit('updateResource', newResource)
    },
    postResource(newResource) {
      this.$emit('postResource', newResource)
    },
    setRTL() {
      this.$refs.editorV[0].quill.format('direction', 'rtl');
      this.$refs.editorV[0].quill.format('align', 'right');
    },

          

    
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
  },
  mounted(){
    
  }
}
</script>

<style>

</style>